import type { SupportedLanguage } from './types';

export interface LanguageDisplayName {
  native: string;
  english: string;
}

// Hand-written: Intl.DisplayNames lowercases some native names ("français").
export const LANGUAGE_DISPLAY_NAMES: Record<
  SupportedLanguage,
  LanguageDisplayName
> = {
  en: { native: 'English', english: 'English' },
  es: { native: 'Español', english: 'Spanish' },
  'pt-BR': { native: 'Português (Brasil)', english: 'Portuguese (Brazil)' },
  de: { native: 'Deutsch', english: 'German' },
  fr: { native: 'Français', english: 'French' },
  it: { native: 'Italiano', english: 'Italian' },
};
